import RepresentativeListWithCreate from './RepresentativeListWithCreate'

export default RepresentativeListWithCreate
